import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  FIELDTYPE_TITLE,
  HEARINGSTATUS_AWAITING_CONCLUSION,
  HEARINGSTATUS_CONCLUDED,
  HEARINGSTATUS_CREATED,
} from '../../../constants/api';
import {
  getAllHearingsInitialize,
  getAllHearingTypesInitialize,
} from '../../../features/actions/api';
import { allContentSelector } from '../../../features/apiFeatures/contentSlice';
import { allFieldsSelector } from '../../../features/apiFeatures/fieldSlice';
import { allFieldTypesSelector } from '../../../features/apiFeatures/fieldTypeSlice';
import { allHearingRolesSelector } from '../../../features/apiFeatures/hearingRoleSlice';
import { hearingByIdSelector } from '../../../features/apiFeatures/hearingSlice';
import { allHearingStatusSelector } from '../../../features/apiFeatures/hearingStatusSlice';
import { allHearingTypesSelector } from '../../../features/apiFeatures/hearingTypeSlice';
import { allSubjectAreasSelector } from '../../../features/apiFeatures/subjectAreaSlice';
import { allUserHearingRolesSelector } from '../../../features/apiFeatures/userHearingRoleSlice';
import { allUsersSelector } from '../../../features/apiFeatures/userSlice';
import {
  baseApiUrlSelector,
  isAppReadySelector,
} from '../../../features/bootstrapSlice';
import { getAttr } from '../../../features/helpers/apiHelpers';
import { ImageWithMenu } from './ImageWithMenu';
import { HearingInfoBox } from './HearingInfoBox';
import { mapHearingItem } from '../../../utilities/mapHearingItem';
import { RenderHearing } from './RenderHearing';
import { CommentSection } from './hearingDetailsPage/CommentSection';
import { hearingStatusByHearingIdSelector } from '../../../features/selectors/compositeSelectors';
import { allContentTypesSelector } from '../../../features/apiFeatures/contentTypeSlice';
import { updateActiveHearing } from '../../../features/componentFeatures/commentSectionSlice';
import { allCityAreasSelector } from '../../../features/apiFeatures/cityAreaSlice';

const HearingDetailsPage = ({ hearingId }) => {
  const dispatch = useDispatch();

  const isAppReady = useSelector(isAppReadySelector);
  const hearing = useSelector(hearingByIdSelector(hearingId));
  const hearingStatusByHearingId = useSelector(
    hearingStatusByHearingIdSelector(hearingId),
  );
  const hearingStatuses = useSelector(allHearingStatusSelector);
  const hearingTypes = useSelector(allHearingTypesSelector);
  const subjectAreas = useSelector(allSubjectAreasSelector);
  const cityAreas = useSelector(allCityAreasSelector);
  const fieldTypes = useSelector(allFieldTypesSelector);
  const fields = useSelector(allFieldsSelector);
  const contents = useSelector(allContentSelector);
  const userHearingRoles = useSelector(allUserHearingRolesSelector);
  const users = useSelector(allUsersSelector);
  const hearingRoles = useSelector(allHearingRolesSelector);
  const baseApiUrl = useSelector(baseApiUrlSelector);
  const contentTypes = useSelector(allContentTypesSelector);

  const currentHearingStatus = getAttr(hearingStatusByHearingId, 'status');

  const disableConclusion =
    currentHearingStatus !== HEARINGSTATUS_AWAITING_CONCLUSION &&
    currentHearingStatus !== HEARINGSTATUS_CONCLUDED;
  const disableSummary = currentHearingStatus === HEARINGSTATUS_CREATED;
  const disableHearingText = currentHearingStatus === HEARINGSTATUS_CREATED;
  const disableCommentSection = currentHearingStatus === HEARINGSTATUS_CREATED;

  useEffect(() => {
    if (isAppReady) {
      dispatch(updateActiveHearing(hearingId));
    }

    if (!disableConclusion) {
      dispatch(getAllHearingTypesInitialize());
    }

    return function cleanup() {
      dispatch(getAllHearingsInitialize());
    };
  }, [dispatch, hearingId, isAppReady, disableConclusion]);

  const hearingItem = mapHearingItem(
    hearing,
    subjectAreas,
    cityAreas,
    hearingTypes,
    hearingStatuses,
    fieldTypes,
    fields,
    contents,
    users,
    userHearingRoles,
    hearingRoles,
    baseApiUrl,
    contentTypes,
  );

  return (
    <div>
      <ImageWithMenu
        title={hearingItem.title}
        imageUrl={hearingItem.imageUrl}
        imageAltText={hearingItem.imageAltText}
        hearingTypeName={hearingItem.hearingType}
        subjectAreaName={hearingItem.subjectArea}
        cityAreaName={hearingItem.cityArea}
        disableConclusion={disableConclusion}
        disableSummary={disableSummary}
        disableHearingText={disableHearingText}
        disableCommentSection={disableCommentSection}
      />
      <div className="create-hearing-write hearing-details-content">
        <div className="create-form-hearing-simple">
          <RenderHearing
            hearing={hearing}
            isEditMode={false}
            disabledFieldTypes={FIELDTYPE_TITLE}
          />
          <CommentSection
            hearing={hearing}
            hearingStatus={currentHearingStatus}
          />
        </div>
        <div>
          <HearingInfoBox hearing={hearing} disableTitle />
        </div>
      </div>
    </div>
  );
};

export { HearingDetailsPage };
